module.exports = __webpack_public_path__ + "assets/steps-old.6a2f6539.svg";